import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import {
  Button,
  Container,
  Menu,
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import { flashSuccessMessage, flashErrorMessage } from '../../actions/flash';
import { fetchM } from '../../actions/fetchM';
import config from '../../../config';
import NavBar from '../../components/NavBar';
import Form from './Form';
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';

class New extends Component {
  static propTypes = {
    location: PropTypes.shape({
      hash: PropTypes.string,
    }),
    loading: PropTypes.bool,
    auth: PropTypes.shape({
      companyBranch: PropTypes.shape({
        id: PropTypes.number,
      }),
      isHeadquarters: PropTypes.bool,
    }),
    onCheck: PropTypes.func,
    t: PropTypes.func,
  }
  static contextTypes = {
    store: PropTypes.object,
  }
  static mapStateToProps = state => ({
    auth: state.auth,
  })

  constructor(props) {
    super(props);
    this.state = {
      token: null,
      hasChanges: false,
    };
  }
  componentDidMount() {
    this.getToken();
  }
  async getToken() {
    const { store } = this.context;
    let res;
    try {
      res = await store.dispatch(fetchM(`${config.get('bookApiURL')}/staffs/?token`, {
        credentials: 'include',
        method: 'GET',
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: 'An error occurred, please refresh page' }));
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const token = res.headers.get('X-Csrf-Token');
      this.setState({
        token,
      });
    }
  }
  async submit(validations, staff) {
    const { store } = this.context;
    const errors = validations.filter(v => !v.isValid);
    if (errors.length > 0) {
      store.dispatch(flashErrorMessage({ header: 'Please fix form errors', list: errors.map(l => l.message) }));
      return;
    }
    try {
      await this.form.submit(`${config.get('bookApiURL')}/staffs/`, {
        credentials: 'include',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.state.token,
        },
        body: JSON.stringify(staff),
      });
    } catch (err) {
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      store.dispatch(flashErrorMessage(err));
      return;
    }
    this.setState({ hasChanges: false }, () => {
      this.handleOnCheck(false, (noChanges) => {
        if (noChanges) {
          store.dispatch(push('/users/'));
          store.dispatch(flashSuccessMessage({ header: 'Create Success', message: `${staff.name} successfully created` }));
        }
      });
    });
  }
  handleSubmit = (event) => {
    event.preventDefault();
    const { store } = this.context;
    this.form.handleSubmit(event)
      .catch((err) => {
        Bugsnag.notifyException(err);
        store.dispatch(flashErrorMessage(err));
      });
  }
  handleOnChange = (hasChanges) => {
    if (hasChanges !== this.state.hasChanges) {
      this.setState({ hasChanges }, () => {
        this.handleOnCheck(hasChanges);
      });
    }
  }
  handleOnCheck = (hasChanges = false, callback) => {
    if (this.props.onCheck) {
      this.props.onCheck(hasChanges, callback);
    }
  }
  render() {
    const { t } = this.props;
    return (
      <Container>
        <NavBar
          header={t('New User')}
          rightNav={
            <Menu.Item fitted>
              <Button
                positive
                content={t('Create')}
                onClick={this.handleSubmit}
              />
            </Menu.Item>
          }
        />
        <Form
          ref={(ref) => { this.form = ref; }}
          onSubmit={(validations, staff) => {
            this.submit(validations, staff);
          }}
          onChange={this.handleOnChange}
          location={this.props.location}
          auth={this.props.auth}
          loading={this.props.loading}
        />
      </Container>
    );
  }
}

export default withTranslation([
  ...namespaces,
  TRANSLATION_FILES.models.user,
])(connect(New.mapStateToProps)(New));



// WEBPACK FOOTER //
// ./src/containers/Staffs/New.jsx